import { FormControl } from "@angular/forms";


export function noWhiteSpaceValidator(controlName: string): any {
    return (_formControl: FormControl): { [key: string]: boolean } | null => {
        const control = _formControl;
        const isWhiteSpace = control?.value?.trim().length === 0;
        const isValid = !isWhiteSpace;
        if (isValid) {
            return null
        } else {
            return { "noWhiteSpace": true }
        }
    }
}